var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
const __WEBPACK_NAMESPACE_OBJECT__ = x({ ["PWAInstallElement"]: () => __WEBPACK_EXTERNAL_MODULE__khmyznikov_pwa_install_01c65e58__.PWAInstallElement });